/**
 * FacetWP filters
 */
 var component_facetwp_filters = function(args) {

  // setup args
  var filters = args.filters;

  // Hide facet and its label if it is empty
  function facetsVisibility(facetCodes) {
    facetCodes.forEach(facetCode => {
      let facet = filters.querySelector(`.facetwp-facet-${facetCode}`);
      if (!facet) { return; }
      let facetContainer = facet.parentElement;
      let facet_label = filters.querySelector(`.facetwp-filters__facet-label--${facetCode}`);
      let visible = facet.childNodes.length > 0;
      var display = visible ? 'block' : 'none';

      facet.style.display = display;
      facetContainer.style.display = display;
      if (facet_label) {
        facet_label.style.display = display;
      }
    });
  }

  /**
   * Check if there are active filters
   */
  function checkIfFiltered(facetCodes) {
    if (typeof FWP === 'undefined') { return false; }
    return facetCodes.some(facet => FWP.facets[facet] && FWP.facets[facet].length >= 1);
  }

  if (filters) {
    var facetCodes = filters.dataset.facetwpFacet.split(' ');
    var resetBtn = filters.querySelector('.facetwp-filters__reset-btn');
    resetBtn.addEventListener('click', () => {
      if (typeof FWP !== 'undefined') { FWP.reset(); }
    });
    var resultsCount = filters.querySelector('.facetwp-filters__results-count');

    document.addEventListener('facetwp-loaded', function() {
      if (typeof FWP === 'undefined' || typeof theme_strings === 'undefined') { return; }
      resultsCount.innerHTML = theme_strings.showing + ' ' + FWP.settings.pager.total_rows + ' ' + theme_strings.articles;

      // show and hide reset button
      if (checkIfFiltered(facetCodes)) {
        resetBtn.classList.add('visible');
      } else {
        resetBtn.classList.remove('visible');
      }

      facetsVisibility(facetCodes);
    });
  }

  // make the call chainable
  return this;

};

